import * as React from "react";
const SvgDirectRunning = (props) => /* @__PURE__ */ React.createElement("svg", { id: "b", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 53 53", height: "1em", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M26.5.03C11.86.03,0,11.9,0,26.53s11.86,26.5,26.5,26.5,26.5-11.86,26.5-26.5S41.14.03,26.5.03ZM38.14,28.4l-14.37,8.53c-.51.3-1.1.46-1.69.46-1.83,0-3.31-1.48-3.31-3.31v-15.16c0-.6.16-1.18.46-1.69.93-1.57,2.97-2.09,4.54-1.16l14.37,8.53c.32.19.58.45.77.77.62,1.05.28,2.4-.77,3.03Z", style: {
  fill: "currentColor",
  strokeWidth: 0
} }));
export default SvgDirectRunning;
